
import Vue from "vue";
import FsegLayout from "@/@modules/fseg/components/Layout.vue";
import { GraphqlService } from "@/@modules/fseg/services/GraphqlService";
import { worker } from "@/@modules/fseg/services/store/worker";

export default Vue.extend({
  components: {
    FsegLayout,
  },
  data() {
    return {
      ssin: "" as string | undefined, // ssin is undefined when all chars in field are deleted
    };
  },
  methods: {
    async getWorkerBySsin() {
      if (this.ssin) {
        worker.data = await GraphqlService.getWorkerInfo({
          ssin: this.ssin.replace(/[-/.]/g, ""),
          isAgent: true,
        });

        if (worker.data && worker.data.id) {
          this.$router.push(`/worker/signaletic?id=${worker.data.id}`);
        } else {
          this.$snackbar.show("The ssin is not referenced", 2000);
        }
      }
    },
  },
});
